<div class="mb-2 text-sm">
  <span class="font-semibold">Current email:</span> {{ currentEmail }}
</div>

<form [formGroup]="updateEmailForm" (ngSubmit)="submitHandler()">
  <app-shared-input
    label="New email"
    for="email"
    [value]="updateEmailForm.value.email"
    [focused]="focused"
    [touched]="updateEmailForm.get('email')?.touched"
    [errors]="updateEmailForm.get('email')?.errors"
    [disabled]="loading"
  >
    <input
      id="email"
      formControlName="email"
      name="email"
      type="email"
      (focus)="focused = true"
      (blur)="focused = false"
    />
  </app-shared-input>

  <app-shared-button [loading]="loading"> Update Email </app-shared-button>
</form>
